import { Route } from 'react-router-dom';
import { TurnoGeoHomePage } from '../modules/turno-geo/TurnoGeoHomePage';
import { MarcarTurnoPage } from '../modules/turno-geo/MarcarTurnoPage';
import { RegistradorPage } from '../modules/turno-geo/RegistradorPage';
import { MisRegistrosPage } from '../modules/turno-geo/MisRegistrosPage';
import { NovedadesPage } from '../modules/turno-geo/NovedadesPage';
import { TurnoGeoSettingsPage } from '../modules/turno-geo/TurnoGeoSettingsPage';
import { TurnoGeoOvertimePage } from '../modules/turno-geo/OvertimePage';
import { HoursPage } from '../modules/turno-geo/HoursPage';
import { RequireTurnoGeoModule, RequireTurnoGeoLeader } from '../modules/turno-geo/components/RequireTurnoGeo';

/**
 * Registro de rutas de TurnoGeo - equivalente a router/routes.tsx (Control
 * Operativo) y router/hrRoutes.tsx (Gestion Humana), pero independiente:
 * agregar una pantalla aqui NUNCA toca el router de las otras dos
 * aplicaciones ni el Selector de Aplicacion.
 *
 * Devuelve un Fragment de <Route> (sin <Routes> propio) para anidarse dentro
 * del layout de TurnoGeo en el router raiz (ver App.tsx).
 */
export function TurnoGeoRoutes() {
  return (
    <>
      <Route path="/turno-geo" element={<TurnoGeoHomePage />} />
      <Route path="/turno-geo/marcar" element={<RequireTurnoGeoModule moduleId="turnogeo-mark"><MarcarTurnoPage /></RequireTurnoGeoModule>} />
      <Route path="/turno-geo/mis-registros" element={<RequireTurnoGeoModule moduleId="turnogeo-records"><MisRegistrosPage /></RequireTurnoGeoModule>} />
      <Route path="/turno-geo/novedades" element={<NovedadesPage />} />
      <Route path="/turno-geo/registrador" element={<RequireTurnoGeoModule moduleId="turnogeo-register"><RegistradorPage /></RequireTurnoGeoModule>} />
      <Route path="/turno-geo/horas" element={<RequireTurnoGeoLeader><RequireTurnoGeoModule moduleId="turnogeo-hours"><HoursPage /></RequireTurnoGeoModule></RequireTurnoGeoLeader>} />
      <Route path="/turno-geo/horas-extras" element={<RequireTurnoGeoLeader><RequireTurnoGeoModule moduleId="turnogeo-overtime"><TurnoGeoOvertimePage /></RequireTurnoGeoModule></RequireTurnoGeoLeader>} />
      <Route path="/turno-geo/configuracion" element={<RequireTurnoGeoLeader><RequireTurnoGeoModule moduleId="turnogeo-settings"><TurnoGeoSettingsPage /></RequireTurnoGeoModule></RequireTurnoGeoLeader>} />
    </>
  );
}
